<template>
<div id="representantes">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="COVES" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-col sm="12" md="2">
              <v-menu offset-x ref="menu_fecha_de" v-model="menu_fecha_de" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
              <template v-slot:activator="{ on }" >
                <v-text-field v-on="on" v-model="model_fechas.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model_fechas.fecha_de = parseDate(model_fechas.fecha_de)" v-mask="'####-##-##'"
                    :rules="[validaAnio, validaFecha]" ></v-text-field>
              </template>

              <v-date-picker v-model="model_fechas.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu_fecha_de = false" >
                <v-spacer />

                <v-btn color="secondary" x-small @click="menu_fecha_de = false" >
                  Cancelar
                </v-btn>
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col sm="12" md="2">
              <v-menu offset-x ref="menu_fecha_a" v-model="menu_fecha_a" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }" >
                  <v-text-field v-on="on" v-model="model_fechas.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model_fechas.fecha_a = parseDate(model_fechas.fecha_a)" v-mask="'####-##-##'"
                      :rules="[validaAnio, validaFecha]" ></v-text-field>
                </template>

                <v-date-picker v-model="model_fechas.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu_fecha_a = false" >
                  <v-spacer />

                  <v-btn color="secondary" x-small @click="menu_fecha_a = false" >
                    Cancelar
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-btn color="secondary" @click="cargar" >
                  Consultar
                </v-btn>
            <v-spacer></v-spacer>
            <v-speed-dial direction="left" open-on-hover>
              <template v-slot:activator>
                <v-btn x-small fab dark color="primary">
                  <v-icon>reorder</v-icon>
                </v-btn>
              </template>

              <exportar-excel :data="datafiltered" :exportFields="facturas.camposexcel" name="CovesTransmitidos.xlsx">
                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                  <v-icon dark>get_app</v-icon>
                </v-btn>
              </exportar-excel>
            </v-speed-dial>

          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-refresh-button :funcion="cargar" />
              <v-client-table ref="vuetable" :data="facturas.items" :columns="columnsFacturas" :options="optionsFacturas" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>

                <template slot="error" slot-scope="props">
                  {{ props.row.error != null && props.row.error.includes("HTTPSConnectionPool(host='www.ventanillaunica.gob.mx', port=443)") ? "Servicio de VUCEM no responde" : props.row.error}}
                </template>

                <template slot="xml" slot-scope="props">
                  <span v-if="props.row.xml==0">Pendiente</span>
                  <span v-if="props.row.xml==1">En cola</span>
                  <span v-if="props.row.xml==3">Error al recuperar</span>
                  <span v-if="props.row.xml==4">No recuperable</span>
                  <v-btn text icon color="primary" title="Descargar XML" v-if="props.row.xml==2 && props.row.nombre_cove!=null && props.row.nombre_cove!=''"
                    @click="downloadFile(props.row.nombre_cove, props.row.no_operacion, props.row.id, props.row.no_factura,'xml')">
                    <v-icon dark>insert_drive_file</v-icon>
                  </v-btn>
                </template>

                <template slot="pdf" slot-scope="props">
                  <span v-if="props.row.pdf==0">Pendiente</span>
                  <span v-if="props.row.pdf==1">En cola</span>
                  <span v-if="props.row.pdf==3">Error al generar</span>
                  <span v-if="props.row.pdf==4">No recuperable</span>
                  <v-btn text icon color="primary" title="Descargar PDF" v-if="props.row.pdf==2 && props.row.nombre_cove!=null && props.row.nombre_cove!=''"
                    @click="downloadFile(props.row.nombre_cove, props.row.no_operacion, props.row.id, props.row.no_factura, 'pdf')">
                    <v-icon dark>picture_as_pdf</v-icon>
                  </v-btn>
                </template>

                <template slot="acuse" slot-scope="props">
                  <v-btn text icon color="primary" title="Descargar Acuse" v-if="(props.row.acuse==0 || props.row.acuse==3) && props.row.nombre_cove!=null && props.row.nombre_cove!=''"
                    @click="recuperarAcuse(props.row.id, props.row.no_operacion, props.row.nombre_cove, props.row.no_factura)">
                    <v-icon dark>get_app</v-icon>
                  </v-btn>
                  <span v-if="props.row.acuse==1">En cola</span>
                  <!--span v-if="props.row.acuse==3" >Error al recuperar</span-->
                  <span v-if="props.row.acuse==4">No recuperable</span>
                  <v-btn text icon color="primary" title="Descargar PDF" v-if="props.row.acuse==2 && props.row.nombre_cove!=null && props.row.nombre_cove!=''"
                    @click="downloadFile('Acuse_'+props.row.nombre_cove, props.row.no_operacion, props.row.id, props.row.no_factura, 'pdf')">
                    <v-icon dark>picture_as_pdf</v-icon>
                  </v-btn>
                </template>

                <template slot="evidencia" slot-scope="props">
                  <v-btn text icon color="primary" title="ZIP Evidencia" v-if="props.row.id>4101 && props.row.estatus!='Pendiente'" @click="downloadZipEvidencia(props.row.id, props.row.no_factura, props.row.nombre_cove)">
                    <v-icon dark>get_app</v-icon>
                  </v-btn>
                </template>

                <template slot="layout" slot-scope="props">
                  <v-btn x-small text dark color="purple" v-if="(props.row.id>4101 && props.row.layout!=null && props.row.layout!='')" @click.native="downloadLayout(props.row.layout)" title="Layout Cargado" v-tippy>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-btn>
                  <v-btn x-small text dark color="red" v-if="(props.row.error == 'La operación aun esta en proceso. Favor de intentar más tarde.')" @click.native="reintentarCove(props.row.id)" title="Reintentar Consulta de Cove" v-tippy>
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </template>


              </v-client-table>

            </div>

          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },

  data: () => ({
    menu_fecha_de:"",
    menu_fecha_a:"",
    model_fechas: {
      fecha_de:"",
      fecha_a:""
    },
    fab: false,
    name: "datagrid",
    ws_password: "",
    sello_cer: "",
    sello_pem: "",
    sello_password: "",
    URL: "",
    show_loading: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Vucem-Transmisión",
        disabled: true,
        to: ""
      },
      {
        text: "COVES",
        disabled: true,
        to: ""
      }
    ],
    emisores: [],

    facturas: {
      items: [],
      camposexcel: {
        "fecha": "fecha",
        "no_factura": "no_factura",
        "usuario": "usuario",
        "no_operacion": "no_operacion",
        "nombre_cove": "nombre_cove",
        "partidas": "partidas",
        "estatus": "estatus",
        "fecha_envio": "fecha_envio",
        "error": "error",
        "errores": "errores",
      },
    },
    columnsFacturas: [
      "id",
      "fecha",
      "no_factura",
      "usuario",
      "no_operacion",
      "nombre_cove",
      "partidas",
      "estatus",
      "fecha_envio",
      "error",
      "errores",
      "xml",
      "pdf",
      "acuse",
      "evidencia",
      "layout"
    ],
    optionsFacturas: {
      filterable: [
        "id",
        "fecha",
        "no_factura",
        "usuario",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "fecha_envio",
        "error",
      ],
      sortable: [
        "id",
        "fecha",
        "no_factura",
        "usuario",
        "no_operacion",
        "nombre_cove",
        "partidas",
        "estatus",
        "fecha_envio",
        "error",
      ],
      headings: {
        id: "Num proceso",
        fecha: "Fecha",
        no_factura: "Factura",
        usuario: "Usuario",
        o_operacion: "No. Operación",
        nombre_cove: "COVE",
        partidas: "Partidas",
        estatus: "Estatus",
        fecha_envio: "Fecha Envío",
        error: "Error Transmisión",
        errores: "Error Recuperación",
        xml: "XML",
        pdf: "PDF",
        acuse: "Acuse",
        evidencia: "Evidencias",
        layout: "Layout Cargado"
      }
    },

  }),
  computed: {
    getNameExcel() {
      return "CovesTransmitidos" + this.$local_storage.get("rfc") + ".xlsx";
    },
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.facturas.items;
      }

    },
  },

  methods: {
    downloadLayout: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    reintentarCove: function(id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id_cove: id,
        id_cliente: this.$local_storage.get("id_cliente")
      }

      axios.post(this.$hostname + 'vucem/consultar_cove_pendiente/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El Cove se consulto correctamente, en breve se iniciara su recuperación",
              footer: '',
            });
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un Error",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al consultar";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);

        }).then(() => {
          this.$root.$dialogLoader.hide();
          this.cargar();
        });
    },
    downloadZipEvidencia: function(idCove, no_factura, nombre_cove, intento = 0) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var nombreZip = idCove.toString() + "_" + nombre_cove.toString() + "_evidencias.zip";
      var key = this.$local_storage.get("rfc") + "/reportes/" + nombreZip;
      var datoss3 = {
        id: key,
        bucket: "production.econnect.ds"
      }
      let nombre_download = key.split("/").pop();
      var thisObj = this;
      axios.post(this.$hostname + 's3/download_url/', datoss3)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);
            this.$root.$dialogLoader.hide();
          } else {
            if (intento == 0) {
              thisObj.generaZipEvidencia(idCove, no_factura, nombre_cove);
            } else if (intento > 4) {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al generar ZIP. Favor de intentar nuevamente.",
                footer: '',
              });
              this.$root.$dialogLoader.hide();
            } else {
              setTimeout(function() {
                thisObj.downloadZipEvidencia(idCove, no_factura, nombre_cove, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)

            }

          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;

          if (mensaje.indexOf("El archivo no existe en S3") != -1 && intento <= 4) {
            if (intento == 0)
              thisObj.generaZipEvidencia(idCove, no_factura, nombre_cove);
            else
              setTimeout(function() {
                thisObj.downloadZipEvidencia(idCove, no_factura, nombre_cove, intento + 1);
              }, 10000); //Damos tiempo para generar el zip (10 seg)

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            console.log(error);
            this.$root.$dialogLoader.hide();
          }
        });

    },
    generaZipEvidencia: function(idCove, no_factura, nombre_cove) {
      var datos = {
        rfc: this.$local_storage.get("rfc"),
        id_cove_transmitido: idCove,
        no_factura: no_factura,
        cove: nombre_cove,
        reporte_url: "/reportes_vucem/genera_zip_evidencias/",
        nombre_reporte: "Zip Evidencias Cove",
        tipo: "ZIP_Evidencias_COVE",
        usuario: this.$local_storage.get("id_usuario"),
      };
      var thisObj = this;
      axios.post(this.$hostname + "reportes/save_reporte/", datos)
        .then(res => {
          thisObj.downloadZipEvidencia(idCove, no_factura, nombre_cove, 1);
        })
        .catch(error => {
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            var mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
          } else { //Si es un timeout intentamos descargar el archivo
            thisObj.downloadZipEvidencia(idCove, no_factura, nombre_cove, 1);
          }
          console.log(error);
        });
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateExcel(excelDate) {
      try {
        if (!excelDate) return false;
        var fecha = '';
        if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
          fecha = moment(String(excelDate)).format("YYYY-MM-DD");
        else
          fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
        if (fecha == 'Invalid date') return false;
        return fecha;
      } catch (error) {
        return false;
      }
    },

    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        rfc: this.$local_storage.get("rfc"),
        fecha_de: this.model_fechas.fecha_de,
        fecha_a: this.model_fechas.fecha_a
      };
      axios
        .post(this.URL + "get_detalles_coves/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.facturas.items = res.data;
            this.facturas.items.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha);
            });
            //LOS CAMPOS xml, pdf y acuse, tienen valores (0-Pendiente, 1-En cola, 2-Recuperado, 3-Error, 4-No recuperable)
            for (var k in this.facturas.items) {
              this.facturas.items[k].fecha = this.parseDate(this.facturas.items[k].fecha);
              this.facturas.items[k].fecha_envio = this.parseDate(this.facturas.items[k].fecha_envio);
              this.facturas.items[k].estatus = this.getEstatusDetalle(this.facturas.items[k].estatus);
              if (this.facturas.items[k].errores != null) {
                var errores_string = '';
                var thisObject = this;
                var err_array = this.facturas.items[k].errores.map(function(err) {
                  return thisObject.parseDate(err.fecha) + ": " + err.error;
                });
                err_array.forEach(element => {
                  errores_string += element + ", ";
                });
                this.facturas.items[k].errores = errores_string;
              }
            }

          }
        })
        .catch(err => {

          console.log(err);
        }).then(() => {
          this.cargarCertificados();
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },

    getEstatusDetalle: function(estatus) {
      var arr_estatus = ["Pendiente", "Transmitido", "Aceptado", "Rechazado"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isLt2M) {
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },

    validaCorreo: function(mail) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(mail);
    },

    cargarEmisores: function() {
      var datos = {
        cliente: this.$local_storage.get("id_cliente")
      };
      axios
        .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.emisores = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los emisores.",
            footer: ""
          });
        });
    },

    cargarCertificados: function() {
      var rfc = this.$local_storage.get("rfc");
      var datos = {
        cliente: this.$local_storage.get("id_cliente")
      };
      axios
        .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.sellos = res.data;
            if (this.sellos.length > 0) {
              var search = this.sellos.filter(function(e) {
                return e.estatus == 1 && e.activo == true; //1-Sello correcto
              });
              if (search.length > 0) {
                let sello = search[0];
                this.ws_password = sello.clave_ws;
                this.sello_cer = sello.file_cer;
                this.sello_pem = sello.file_pem;
                this.sello_password = sello.password;
              } else {
                var search2 = this.sellos.filter(function(e) {
                  return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                });
                if (search2.length > 0) {
                  let sello = search2[0];
                  this.ws_password = sello.clave_ws;
                  this.sello_cer = sello.file_cer;
                  this.sello_pem = sello.file_pem;
                  this.sello_password = sello.password;
                }
              }
            }
          }
        })
        .catch(err => {

        });
    },

    recuperarAcuse: function(id_cove, no_operacion, nombre_cove, no_factura) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var key = this.$local_storage.get("rfc") + "/coves/" + no_operacion + "/";
      if (id_cove > 4101) { //A partir de este id, se guardan en otro key
        key = this.$local_storage.get("rfc") + "/coves/" + id_cove.toString() + "/" + no_factura.toString() + "/";
      }

      var estatus = 2; //2-Recuperado

      var datos = {
        tipo: 1, //1-Cove, 2-eDocument
        documento: nombre_cove,
        path: key,
        token: {
          ws_rfc: this.$local_storage.get("rfc"),
          ws_password: this.ws_password
        }
      };
      axios.post(this.$hostname + "vucem/get_acuse/", datos)
        .then(res => {

          this.downloadFile("Acuse_" + nombre_cove, no_operacion, id_cove, no_factura, "pdf");

        })
        .catch(err => {
          estatus = 3; //3-Errores

          var errores = "";
          if (err.response.data != undefined) {
            if (err.response.data.mensaje != undefined) {
              if (typeof err.response.data.mensaje == "string")
                errores += err.response.data.mensaje;
              else
                errores += err.response.data.mensaje[0];

            } else {
              Object.keys(err.response.data).forEach(function(key) {
                if (typeof err.response.data[key] == 'string')
                  errores += key + ": " + err.response.data[key];
                else if (typeof err.response.data[key] == 'object') {
                  Object.keys(err.response.data[key]).forEach(function(key2) {
                    if (typeof err.response.data[key][key2] == 'string')
                      errores += key + ": " + err.response.data[key][key2];
                    else if (typeof err.response.data[key][key2] == 'object')
                      errores += key2 + ": " + err.response.data[key][key2][0];
                  });
                }
                //errores += key + ": " + err.response.data[key][0];
                errores += "<br>";
              });

            }
          }

          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al recuperar el acuse.",
            footer: errores
          });
          console.log(err);
        }).then(() => {
          axios.post(this.URL + "actualiza_acuse/", {
              cove: nombre_cove,
              id: id_cove,
              estatus: estatus
            })
            .then(res => {

            }).catch(err => {

            });
          this.registro_seleccionado = id_cove;
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    downloadFile: function(nombre, no_operacion, id_cove, no_factura, tipo) {
      //Tipo: xml, pdf
      var rfc = this.$local_storage.get("rfc") + "/coves/" + no_operacion + "/";
      if (id_cove > 4101) { //A partir de este id, se guardan en otro key
        rfc = this.$local_storage.get("rfc") + "/coves/" + id_cove.toString() + "/" + no_factura.toString() + "/";
      }
      var key = rfc + nombre + "." + tipo;

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.download = "test.xml";
            //a.download = name[name.length - 1];
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

  }, //methods

  created: function() {
    this.URL = this.$hostname + "transmitir_cove/";
    const hoy = moment();
    this.model_fechas.fecha_a = hoy.format("YYYY-MM-DD");
    this.model_fechas.fecha_de = hoy.clone().subtract(15, "days").format("YYYY-MM-DD");
    this.cargar();

  }
};
</script>
